import i18n from "i18next";

/**
 * Points the page at the web app manifest of the UI language.
 *
 * A manifest has a single `description` and single screenshot labels: the
 * localized members are still a W3C proposal no browser ships. So there is
 * one manifest per language (same `id`, hence the same installed app), and
 * the `<link rel="manifest">` follows i18next. The browser reads it when the
 * install prompt opens, so the user sees the text of the language they use.
 *
 * Resolution is by the language's first two letters, like dateLocale.ts;
 * anything else gets the English one, i18next's fallback.
 */
const MANIFESTS: Record<string, string> = {
	fr: "/manifest.fr.json",
	en: "/manifest.en.json",
};

export const manifestFor = (language: string | undefined): string =>
	MANIFESTS[(language ?? "").slice(0, 2).toLowerCase()] ?? MANIFESTS.en;

const applyManifest = (language: string | undefined): void => {
	const link = document.querySelector<HTMLLinkElement>(
		'link[rel="manifest"]'
	);
	const href = manifestFor(language);

	// Same href: leave the element alone, the browser would refetch it.
	if (link && link.getAttribute("href") !== href) {
		link.setAttribute("href", href);
	}
};

export const syncManifestWithLanguage = (): void => {
	applyManifest(i18n.language);

	i18n.on("languageChanged", applyManifest);
};
